export default (recordClickActionId, recordId) => (
	`${recordClickActionId}-${recordId}`
)
